import { render } from "./page-layanan.vue?vue&type=template&id=3e094b62&scoped=true"
import script from "./page-layanan.vue?vue&type=script&lang=js"
export * from "./page-layanan.vue?vue&type=script&lang=js"

import "./page-layanan.vue?vue&type=style&index=0&id=3e094b62&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e094b62"]])

export default __exports__